//@ts-ignore
import { CLESSON_MODES } from '@yandex-int/k-common/constants';
import { Text } from 'platform-components';
import React from 'react';
import { connect } from 'react-redux';

import * as lessonSelectors from 'common.components/lesson/selectors';

import './side-panel__lesson-mode.scss';

interface StoreProps {
    lessonMode: CLESSON_MODES | null;
}

interface Props extends StoreProps {}

export const LessonMode = ({ lessonMode }: Props) => {
    return (
        <div className="side-panel__lesson-mode" data-mode={lessonMode}>
            <Text id={`assignLessonModal.lessonModes.mode.${lessonMode}`} weight={Text.WEIGHT.M} />
        </div>
    );
};

const mapStateToProps = (storeState: any): StoreProps => {
    return {
        lessonMode: lessonSelectors.getLessonMode(storeState),
    };
};

const connected = connect(mapStateToProps)(LessonMode);
connected.displayName = 'LessonMode';

export default connected;
